import { useQuery } from '@apollo/client'
import { createContext, useContext, useEffect } from 'react'

import { Contact } from '../graphql/query/contact'
import { useOrganization } from './OrganizationContext'
import { useSessionStorage } from '../hooks/SessionStorage'

export const RecentlyViewedContactsContext = createContext<
  IRecentlyViewedContactsContext | undefined
>(undefined)

interface IRecentlyViewedContactsContext {
  add: (contact: Contact) => void
  clear: () => void
  contacts: Contact[]
}

export const RecentlyViewedContactsProvider: React.FunctionComponent = ({ children }) => {
  const [contacts, setContacts] = useSessionStorage<Contact[]>('recentlyViewedContacts', [])

  const render = (value: IRecentlyViewedContactsContext) => (
    <RecentlyViewedContactsContext.Provider value={value}>
      {children}
    </RecentlyViewedContactsContext.Provider>
  )

  const add = (contact: Contact) => {
    const newContacts: Contact[] = contacts
    const idx = newContacts.findIndex((c) => c.id === contact.id)
    if (idx !== -1) {
      newContacts.splice(idx, 1)
    }
    newContacts.unshift(contact)

    setContacts(newContacts)
  }

  const clear = () => {
    setContacts([])
  }

  return render({ add, clear, contacts })
}

export const useRecentlyViewedContacts = () => {
  const context = useContext(RecentlyViewedContactsContext)
  if (context === undefined) {
    throw new Error(
      'useRecentlyViewedContacts must be used within a RecentlyViewedContactsProvider',
    )
  }
  return context
}
